<template>
  <div>
    <bread-crumb></bread-crumb>
    <manFormList
      :select="select"
      :selectList="selectList"
      @getChangeValue="getChangeValue"
      @empty="empty"
      :num="1"
      :isBtn="1"
    ></manFormList>
    <div class="wiki-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          v-for="(item, index) in jbbkTabList"
          :key="index"
        >
          <span slot="label" class="slot-item">
            <span>{{ item.title }}</span
            ><span>{{ item.count }}</span>
          </span>
          <div class="base-table">
            <div class="base-table-table">
              <el-table :data="jbbkList">
                <el-table-column prop="contentId" label="疫苗ID" />
                <el-table-column prop="contentName" label="疫苗名称" />
                <el-table-column label="创建人">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.authors && scope.row.authors.length > 0
                        ? scope.row.authors[0].nickName
                        : scope.row.createUser
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column prop="auditTime" label="审核时间">
                  <template slot-scope="scope">
                    {{ scope.row.auditInfo.auditTime }}
                  </template>
                </el-table-column>
                <el-table-column prop="auditUser" label="审核人">
                  <template slot-scope="scope">
                    {{ scope.row.auditInfo.auditUser }}
                  </template>
                </el-table-column>
                <el-table-column prop="auditUser" label="编审医生">
                  <template slot-scope="scope">
                    <div
                      v-html="doctorInfosOrDoctor(scope.row.doctorInfos)"
                    ></div>
                  </template>
                </el-table-column>
                <el-table-column prop="auditStatus" label="审核状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.auditInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.auditInfo.auditStatus == 4"
                    >
                      <div
                        :class="
                          scope.row.auditInfo.auditStatus == 4 ? 'rejected' : ''
                        "
                      >
                        {{ scope.row.auditInfo.auditStatus | auditStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      {{ scope.row.auditInfo.auditStatus | auditStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="auditStatus" label="百科状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="reasonForOffline"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.contentStatus == 2"
                    >
                      <div
                        :class="scope.row.contentStatus == 2 ? 'rejected' : ''"
                        @mouseenter="remarkContent(scope)"
                      >
                        {{ scope.row.contentStatus | contentStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      {{ scope.row.contentStatus | contentStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.auditInfo.auditStatus == 2"
                        @click="toAuditPage(scope.row)"
                        >审核
                      </el-button>
                      <span
                        class="border"
                        v-if="
                          scope.row.auditInfo.auditStatus == 2 &&
                          scope.row.contentStatus == 1
                        "
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          scope.row.auditInfo.auditStatus == 1
                            ? false
                            : scope.row.auditInfo.auditStatus == 2
                            ? false
                            : true
                        "
                        @click="toEditPage(scope.row)"
                        >编辑
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          scope.row.auditInfo.auditStatus == 1 &&
                          scope.row.contentStatus == 2
                        "
                        @click="toEditPage(scope.row)"
                        >编辑
                      </el-button>
                      <span
                        class="border"
                        v-if="
                          scope.row.contentStatus == 1 &&
                          scope.row.auditInfo.auditStatus !== 2 &&
                          scope.row.auditInfo.auditStatus !== 1
                        "
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.contentStatus == 1"
                        @click="articlePreview(scope.row)"
                        >查看线上
                      </el-button>
                      <span
                        class="border"
                        v-if="scope.row.contentStatus == 1"
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        @click="offlineDisease(scope.row)"
                        v-if="scope.row.contentStatus == 1"
                        >下线
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    />
    <modal
      :isShow.sync="seeReasonDialog"
      title="查看理由"
      :isShowBtn="isShowBtn"
      @one="handleDialog(false)"
      @update:isShow="handleDialog(false)"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="理由" prop="nameValue"
            >{{ reason }}
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="offlineDialog"
      title="下线"
      :width="width"
      :isShowBtn="isShowBtn"
      :btnText="['取消', '确认']"
      @clickHandler="offlineClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px">
        <span class="red">*</span>
        <el-form-item label="下线理由" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入下线理由，不超过200字"
            v-model="offLineReasons"
            maxlength="200"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import manFormList from "@/entrys/man/components/manFormList.vue";
import breadCrumb from "@/components/breadCrumb";
import pagination from "@/components/pagination";
import modal from "@/components/modal";
import {
  getReviewStatus,
  getDiseaseSymptoms,
  changgeDiseaseSymptomsOnline,
} from "@/api/symptomaticDisease";

export default {
  name: "diseaseList",
  data() {
    return {
      // 疫苗百科
      contentType: 16,
      // 搜索
      selectList: {
        queryItem: "", // 输入疫苗ID
        selectDiseaseInfoId1: "", // 输入疫苗名称
        submissionTime: [], // 投稿时间
        contentStatus: "", // 问文章状态
      },
      select: [
        {
          prop: "queryItem",
          type: "input",
          placeholder: "请输入疫苗ID",
        },
        {
          prop: "selectDiseaseInfoId1",
          type: "input1",
          placeholder: "请输入疫苗名称",
        },
        {
          prop: "submissionTime",
          type: "picker",
          placeholder: "请选择投稿时间",
        },
        {
          prop: "contentStatus",
          type: "select",
          placeholder: "请选择百科状态",
          List: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "已上线",
              value: 1,
            },
            {
              label: "已下线",
              value: 2,
            },
          ],
        },
      ],
      // Tab
      activeName: "all",
      jbbkTabList: [
        {
          name: "all",
          title: "全部",
          count: 0,
          type: "allCount",
        },
        {
          name: "unaudit",
          title: "待审核",
          count: 0,
          type: "unAuditCount",
        },
        {
          name: "approved",
          title: "审核通过",
          count: 0,
          type: "passAuditCount",
        },
        {
          name: "rejected",
          title: "已驳回",
          count: 0,
          type: "rejectCount",
        },
      ],
      offLineReasons: "",
      offLineInfo: "",
      contentAuditStatusList: [1, 2, 3, 4],
      // 表格
      jbbkList: [],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      articleListCode: 0,
      seeReasonDialog: false, // 查看理由弹框
      isShowBtn: [true, true, false],
      offlineDialog: false,
      reason: "", //理由
      reasonForOffline: "",
    };
  },
  components: {
    manFormList,
    breadCrumb,
    pagination,
    modal,
  },
  created() {
    // 是否由文章详情页跳转本页面
    this.initializeJump();
    this.pageDiseaseInfoDraftList();
    this.getDiseaseDraftCountList();
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("vaccines");
  },
  filters: {
    auditStatus: function (data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "审核通过";
        case 4:
          return "已驳回";
      }
    },
    contentStatus: function (data) {
      switch (data) {
        case 1:
          return "已上线";
        case 2:
          return "已下线";
        default:
          return "";
      }
    },
  },
  methods: {
    // 回到列表页 跳转
    initializeJump() {
      // 是否由文章详情回到列表页
      if (sessionStorage.getItem("vaccines")) {
        let contentStatus = sessionStorage.getItem("contentAuditStatus");
        this.paginationDataProduct.currentPage =
          sessionStorage.getItem("currentPage");
        this.selectList = JSON.parse(sessionStorage.getItem("select"));
        this.activeName = sessionStorage.getItem("activeName");
        if (contentStatus == "1,2,3,4") {
          this.contentAuditStatusList = [1, 2, 3, 4];
        } else {
          this.contentAuditStatusList = [contentStatus];
        }
      } else {
        this.paginationDataProduct.currentPage = 1;
        this.selectList.queryItem = "";
        this.selectList.selectDiseaseInfoId1 = "";
        this.selectList.submissionTime = [];
        this.selectList.contentStatus = "";
        this.activeName = "all";
        this.auditStatus = [1, 2, 3, 4];
      }
    },
    doctorInfosOrDoctor(data, type) {
      let doctorInformation = "";
      data.map((item) => {
        item.roleType == 2
          ? (doctorInformation =
              item.docName +
              " " +
              item.titleName +
              " " +
              "ID: " +
              item.docId +
              " " +
              item.hospitalGradeName +
              " " +
              item.hospitalName +
              " " +
              item.departName)
          : "";
      });
      return doctorInformation;
    },
    // 查看线上
    articlePreview(row) {
      const isDev = process.env.VUE_APP_BASEURL == "//beta-api.m.jd.com";
      const betaUrl = "https://cont-yf.healthjd.com/";
      const onlineUrl = "https://cont.healthjd.com/";
      window.open(
        `${isDev ? betaUrl : onlineUrl}wiki/vaccine/${row.contentId}`
      );
    },
    remarkContent(i) {
      if (i.row.statusInfo) {
        this.reasonForOffline = i.row.statusInfo.remark;
      } else {
        this.reasonForOffline = "";
      }
    },
    handleClick(tab, event) {
      if (tab.name == "all") {
        this.articleListCode = 0;
      } else if (tab.name === "unaudit") {
        this.articleListCode = 2;
      } else if (tab.name === "approved") {
        this.articleListCode = 3;
      } else if (tab.name === "rejected") {
        this.articleListCode = 4;
      }
      if (this.articleListCode !== 0) {
        this.contentAuditStatusList.splice(
          0,
          this.contentAuditStatusList.length
        );
        this.contentAuditStatusList.push(this.articleListCode);
      } else {
        this.contentAuditStatusList = [1, 2, 3, 4];
      }
      this.pageDiseaseInfoDraftList("1");
      this.getDiseaseDraftCountList();
    },
    // 查询文章
    getChangeValue(data) {
      if (this.$utils.checkNumber(data.queryItem)) {
        this.pageDiseaseInfoDraftList("1");
        this.getDiseaseDraftCountList();
      } else {
        this.$message({
          message: "ID只能为数字",
          type: "warning",
        });
      }
    },
    // 跳转审核页
    toAuditPage(data) {
      this.$router.push({
        path: "/wikiManage/vaccinesEdit",
        query: {
          id: data.contentId,
          contentType: this.contentType,
          articleType: data.contentType,
        },
      });
      this.setStorage();
    },
    // 跳转编辑页
    toEditPage(data) {
      this.$router.push({
        path: "/wikiManage/vaccinesEdit",
        query: {
          id: data.contentId,
          contentType: this.contentType,
          actionType: 1,
          articleType: data.contentType,
        },
      });
      this.setStorage();
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("contentAuditStatus", this.contentAuditStatusList);
      sessionStorage.setItem("activeName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      sessionStorage.setItem("select", selectStr);
    },
    // /wikiManage/wikiEdit
    // 查看理由
    seeReason(data) {
      this.seeReasonDialog = true;
      this.reason = data.auditInfo.remark;
    },
    // 下线文章
    offlineDisease(data) {
      this.offLineReasons = "";
      this.offlineDialog = true;
      this.getOffLineInfo(data);
    },
    getOffLineInfo(data) {
      this.offLineInfo = data;
    },
    // 下线
    offlineClickHandler(type) {
      if (type == "one") {
        this.offlineDialog = false;
      } else if (type == "two") {
        if (this.offLineReasons === "") {
          this.$message.error("请输入下线理由");
          return;
        }
        // this.offlineDialog = true
        changgeDiseaseSymptomsOnline({
          contentId: this.offLineInfo.contentId,
          tenantId: this.$commonJs.getTenantId(),
          contentStatus: 2,
          remark: this.offLineReasons,
        }).then((res) => {
          this.$message.success("下线成功");
          this.offlineDialog = false;
          this.pageDiseaseInfoDraftList();
        });
      }
    },
    getParams() {
      let params;
      return (params = {
        contentType: this.contentType,
        contentId: this.selectList.queryItem || null,
        aliasNamePrecise: this.selectList.selectDiseaseInfoId1 || null,
        contentStatus: this.selectList.contentStatus
          ? [this.selectList.contentStatus]
          : [],
        tenantId: this.$commonJs.getTenantId(),
        startTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        auditStatus: [1, 2, 3, 4],
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      });
    },
    // 获取各种状态的数量
    getDiseaseDraftCountList() {
      let params = this.getParams();
      getReviewStatus(params).then((res) => {
        this.jbbkTabList.forEach((item) => {
          item.count = res[item.type];
        });
      });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageDiseaseInfoDraftList();
    },
    // 获取症状百科列表数据
    pageDiseaseInfoDraftList(val) {
      if (val == "1") {
        this.paginationDataProduct.currentPage = 1;
      }
      var patrn = /[0-9]/im;
      if (this.selectList.queryItem && !patrn.test(this.selectList.queryItem)) {
        return this.$message.error("请填写正确的ID");
      }
      let params = this.getParams();
      params.auditStatus = this.contentAuditStatusList;
      getDiseaseSymptoms(params).then((res) => {
        this.jbbkList.splice(0, this.jbbkList.length);
        res.data.map((item) => {
          this.jbbkList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
      });
    },
    handleDialog(val) {
      this.seeReasonDialog = val;
    },
    offlineDialogHandel(data) {
      this.offlineDialogShow = data;
    },
    // 清空筛选
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.pageDiseaseInfoDraftList();
      this.getDiseaseDraftCountList();
    },
  },
};
</script>

<style lang="scss" scoped>
.wiki-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.freezeDom {
  margin-top: 30px;

  .freezeInp {
    maxheight: 280px;
    max-width: 276px;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  :deep(.el-textarea__inner) {
    min-height: 145px !important;
    max-height: 280px !important;
  }

  :deep(.el-form-item__label) {
    line-height: 15px;
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

:deep(.cell) {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 30px 26px !important;
  font-size: 14px;
  color: #2c3443;
}

.red {
  margin-left: 24px;
  position: absolute;
  color: red;
}

.rejected:hover {
  cursor: pointer;
  color: red;
}
</style>
